"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _templateObject = _taggedTemplateLiteral(["\n    color: ", ";\n    background: ", ";\n    padding: ", "em\n        ", "em 0;\n    margin-bottom: ", "em;\n    overflow: hidden;\n"], ["\n    color: ", ";\n    background: ", ";\n    padding: ", "em\n        ", "em 0;\n    margin-bottom: ", "em;\n    overflow: hidden;\n"]);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TabContent = _styledComponents2.default.div(_templateObject, function (props) {
    return props.theme.tabordion.content.color;
}, function (props) {
    return props.theme.tabordion.active.background;
}, function (props) {
    return props.theme.tabordion.padding;
}, function (props) {
    return props.theme.tabordion.padding / 2;
}, function (props) {
    return props.theme.tabordion.margin;
});

TabContent.displayName = "TabContent";

exports.default = TabContent;


//////////////////
// WEBPACK FOOTER
// ./~/rla-components/dist/components/tabs/tabContent.js
// module id = 1022
// module chunks = 95715928098905 168707334958949